import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VideoCut } from '@shared/models';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CaseSessionsService } from './case-sessions.service';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private http: HttpClient = inject(HttpClient);
  private readonly sessions = inject(CaseSessionsService);

  private readonly videoCutEndpoint = `${environment.apiUrl}/v1/video-cuts`;

  listVideoCuts(videoId: string): Observable<VideoCut[]> {
    return this.http.get<VideoCut[]>(this.videoCutEndpoint, {
      params: { videoId },
    });
  }

  updateVideoCut(cutId: string, data: { title: string }): Observable<VideoCut> {
    return this.http
      .put<VideoCut>(`${this.videoCutEndpoint}/${cutId}`, data)
      .pipe(
        tap((updatedCut) => this.sessions.get(updatedCut.videoId)?.updateVideoCuts(updatedCut)),
      );
  }

  deleteVideoCut(videoCut: VideoCut): Observable<void> {
    return this.http
      .delete<void>(`${this.videoCutEndpoint}/${videoCut.cutId}`)
      .pipe(tap(() => this.sessions.get(videoCut.videoId)?.deleteVideoCut(videoCut.cutId)));
  }

  retryVideoCut(cutId: string): Observable<VideoCut> {
    return this.http
      .post<VideoCut>(`${this.videoCutEndpoint}/${cutId}/retry`, {})
      .pipe(
        tap((updatedCut) => this.sessions.get(updatedCut.videoId)?.updateVideoCuts(updatedCut)),
      );
  }
}
